module.exports = __webpack_public_path__ + "img/face-bk.46993d2c.png";